import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  searchedUserDetails: any | null;
  selectedOrgId: string | null;
  selectedStoreId: string | null;
}

const initialState: UserState = {
  searchedUserDetails: null,
  selectedOrgId: null,
  selectedStoreId: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSearchedUserDetails: (state, action: PayloadAction<any>) => {
      state.searchedUserDetails = action.payload;
    },
    setSelectedOrgId: (state, action: PayloadAction<string | null>) => {
      state.selectedOrgId = action.payload;
    },
    setSelectedStoreId: (state, action: PayloadAction<string | null>) => {
      state.selectedStoreId = action.payload;
    },
  },
});

export const { setSearchedUserDetails, setSelectedOrgId, setSelectedStoreId } = userSlice.actions;
export default userSlice.reducer;
